module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av259-8fe902c15cdde213f77a230722ca6a8a.jpg";